<mat-card class="admin-card">

  <div class="settings-header">

    <div>
      <h2>Settings</h2>

      <p>
        Manage global application settings.
      </p>
    </div>

  </div>

  <div class="settings-list">

    <div class="setting-item">

      <div class="setting-info">
        <div class="setting-title">
          Registration Enabled
        </div>

        <div class="setting-description">
          Allow new users to register accounts.
        </div>
      </div>

      <mat-slide-toggle
        [(ngModel)]="registration_enabled"
        (change)="updateSettings()"
        [disabled]="isUpdating"
      >
      </mat-slide-toggle>

    </div>

    <div class="setting-item">

      <div class="setting-info">
        <div class="setting-title">
          Login Enabled
        </div>

        <div class="setting-description">
          Allow users to login to the application.
        </div>
      </div>

      <mat-slide-toggle
        [(ngModel)]="login_enabled"
        (change)="updateSettings()"
        [disabled]="isUpdating"
      >
      </mat-slide-toggle>

    </div>

  </div>

</mat-card>